// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__Q+W41","input":"SearchInput_input__rEoWW","iconWrap":"SearchInput_iconWrap__8B7Pk"};